export default{
    userStatus:'1',// 0->普通 1->vip 2->高级vip
    vipLevel:"",
    userInfo:{}
}


// WEBPACK FOOTER //
// ./src/store/modules/state.js